import RoomIcon from "@mui/icons-material/Room";
import Box from "@mui/material/Box";
import React from "react";
import { BreakReportsRow } from "../../../api/models/BreakReportsRow";
import {
    HeadCell,
    SortableTable,
    newDisplayCond,
} from "../../../components/table/sortableTable";
import { convertMinToDisplayFormat } from "../../../services/common/convert";
import { updater } from "../Breaks/BreaksScreen";

import { colors } from "../../../theme";

import {
    LoadingTableElement,
    NullTableElement,
} from "../../../components/table/nullTable";
import { convertUTCtoJST } from "../../../utils/formatting";

export const convertBreakReportsToDataTableFormat = (
    breakReportsList?: BreakReportsRow[] | null
): Row[] => {
    if (!breakReportsList) {
        return [];
    }

    const _data = breakReportsList.map((rec: BreakReportsRow) => {
        const breakMin = rec.breakSec ? Math.floor(rec.breakSec / 60) : 0;

        return {
            break_city: rec.breakCityName,
            break_start_time: rec.breakStartTs,
            break_min: breakMin,
            lat: rec.breakLocLat,
            lng: rec.breakLocLng,
            recId: rec.recId,
            row_id: `${rec.breakStartTs}-${rec.recId}`,
        } as Row;
    });
    return _data;
};

interface TableProps {
    breaks?: BreakReportsRow[] | null;
}

export const BreaksTable: React.FC<TableProps> = (props: TableProps) => {
    // TODO: move scrollTo to a util
    window.scrollTo({ top: 0, behavior: "smooth" });
    const _data = convertBreakReportsToDataTableFormat(props.breaks);

    const handleRowClick = (r) => {
        console.log("r", r);
    };

    if (!props.breaks) {
        return <LoadingTableElement />;
    }

    if (props.breaks.length == 0) {
        return <NullTableElement />;
    }

    return (
        <SortableTable
            tableHeaders={headCells}
            tableData={_data}
            tableProps={props}
            displayCond={newDisplayCond("break_start_time", "asc", 0, 20)}
            rowIdField={"row_id"}
            onRowClickMethod={handleRowClick}
            slimRows={true}
        />
    );
};

type Row = {
    break_city?: string;
    break_start_time?: string;
    break_min?: number;
    lat?: number;
    lng?: number;
    recId: string;
};

const headCells: HeadCell[] = [
    {
        label: "停車場所",
        id: "break_city",
        numeric: false,
        grow: 3,
        wrap: true,
    },
    {
        label: "停車開始時刻",
        id: "break_start_time",
        align: "right",
        numeric: true,
        grow: 2,
        headerAlignRight: true,
        format: (x: string, row: any) => {
            return convertUTCtoJST(x);
        },
    },
    {
        label: "停車時間",
        id: "break_min",
        align: "right",
        numeric: true,
        grow: 2,
        headerAlignRight: true,
        format: (x: number, row: any) => {
            return convertMinToDisplayFormat(x);
        },
    },
    {
        label: "地図",
        id: "row_id",
        numeric: false,
        grow: 2,
        cell: function UpdateMapElementCell(r) {
            return <LinkToMap selectedRecord={r} />;
        },
    },
];

interface MapLinkProps {
    selectedRecord: Row;
}

const LinkToMap: React.FC<MapLinkProps> = (props: MapLinkProps) => {
    return (
        <Box sx={{ cursor: "pointer" }}>
            <RoomIcon
                sx={{
                    color: colors.green.maplink,
                    fontSize: "48px",
                    p: 1,
                }}
                onClick={(x) => {
                    console.debug(
                        "MapButton selected breaks record loc...",
                        props.selectedRecord,
                        props.selectedRecord.lat,
                        props.selectedRecord.lng
                    );

                    updater(
                        props.selectedRecord.lng,
                        props.selectedRecord.lat,
                        props.selectedRecord.recId
                    );
                }}
            />
        </Box>
    );
};
